import React, { FC, useMemo, useState } from 'react';
import { SupportedLlm } from '../../models/User';
import { UIIcon } from '../controls/ui/UIIcon/UIIcon';
import { UITooltip } from '../controls/ui/UIToolTip/UIToolTip';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../shadcn/lib/components/popover';
import { llms, LLMSelectList } from './LLMSelectList';

interface LLMSelectPopoverBtnProps {
  selectedLlm: SupportedLlm | null;
  setSelectedLlm: (newLlm: SupportedLlm | null) => void;
  setOpenPaywallModal(): void;
}

export const LLMSelectPopoverBtn: FC<LLMSelectPopoverBtnProps> = ({
  selectedLlm,
  setSelectedLlm,
  setOpenPaywallModal,
}) => {
  const [showPopover, setShowPopover] = useState(false);

  const llmIcon = useMemo(
    () => llms.find((llm) => llm.value === selectedLlm)?.icon,
    [selectedLlm]
  );

  return (
    <Popover onOpenChange={setShowPopover} open={showPopover}>
      <PopoverTrigger asChild>
        <div>
          <UITooltip title="Select LLM">
            <div className="flex items-center hover:bg-cloud-10 p-2 rounded-md cursor-pointer border-gray-30 border-solid border">
              {llmIcon && <UIIcon name={llmIcon} size={16} type="apps" />}
              <UIIcon
                className="sm:inline hidden hover:pt-1"
                name="arrow-down"
              />
            </div>
          </UITooltip>
        </div>
      </PopoverTrigger>
      <PopoverContent className="z-10 bg-white p-0">
        <LLMSelectList
          defaultLlm={selectedLlm}
          handleLlmSelect={setSelectedLlm}
          nonEnterpriseOnlyListItemClass="hover:bg-cloud-10"
          setPaywallModalOpen={setOpenPaywallModal}
        />
      </PopoverContent>
    </Popover>
  );
};
